module.exports = __webpack_public_path__ + "img/examination-placeholder.48f8a4fa.png";